/* FILE GENERATED BY packages/components/design-tokens/build-scripts/breakpoints.js DO NOT CHANGE */

export const breakpoints = {xs: 0, sm: 479, md: 744, lg: 1025, xl: 2000};
export type Breakpoint = keyof typeof breakpoints;
export const breakpointNames: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl'];
